import styled from 'styled-components';
import { IonPage } from '@ionic/react';

export const IonPageWrapper = styled(IonPage)`
  ion-content {
    --background: linear-gradient(rgba(100, 100, 100, 0.8), rgba(100, 100, 100, 1.0)), url('assets/bg.jpg') no-repeat center/cover fixed;
    --background-size: cover;
  }

  .app-item {
    
    &.heading {
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    &.item {
      margin-top: 1rem;
    }

    .title {
      margin-bottom: 0.5rem;
    }
    color: var(--ion-color-primary);
    font-size: 1rem;
    padding-left: 30px;
    padding-right: 30px;
    
    .highlight {
      color: #fff;
      font-weight: 500;
    }
  }

  .app-copyright {
    color: var(--ion-color-white);
    position: absolute;
    bottom: 0;
    margin-bottom: 3rem;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  ion-toolbar {
    --background: #68b8fc14;
    position: absolute;
  }
`;